import { instanceApi } from '../../../services';

export const getClosedPositions = (email: string, fromDate: string, toDate: string): Promise<any> => instanceApi.get(`api/RebateReport/ClosedPositions?email=${email}&fromDate=${fromDate}&toDate=${toDate}`);
